<script>
    import IconSun from '@/components/icon/IconSun.vue';
    
    export default {
        components: {
            IconSun: IconSun,
        },
        computed: {
            getState() { return this.$store.getters.IS_BLACK_THEME },
        },
        methods: {
            async toggleTheme() {
                this.$store.commit('IS_BLACK_THEME', !this.getState);
                await this.$store.dispatch('SAVE_LOCAL_STORAGE');
                await this.$store.dispatch('CHANGE_THEME');
            }
        }
    }
</script>


<template>
    <button 
        class="theme_button cursor_pointer"
        @click="toggleTheme"
    >
        <IconSun 
            iconHeight="25px"
            iconWidth="25px"
        />
    </button>
</template>


<style scoped>
    .theme_button {
        margin-top: 10px;
        border: none;
        border-radius: 5px;
        width: 35px;
        height: 35px;
        position: fixed;
        left: 5px;
        bottom: 5px;
        z-index: 99;
        background-color: var(--left-button);
        color: var(--left-button-text)
    }
    .theme_button:hover {
        background-color: var(--left-button-hover);
    }
</style>